import {
  faFacebook,
  faGoogle,
  faInstagram,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useContext } from 'react';
import { openInNewWindow } from '@bepro-travel/fe.utils';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { MainContext } from '../contexts/MainContext';

const Footer = () => {
  const { footer, siteConfig } = useContext(MainContext);

  return (
    <div className="footer-wrapper">
      <div className="footer">
        <div className="col-md-3 col-12">
          <img src={require('../assets/img/logo.png')} alt="Logo" />

          {!!siteConfig &&
            (!!siteConfig.facebook ||
              !!siteConfig.instagram ||
              !!siteConfig.twitter ||
              !!siteConfig.google ||
              !!siteConfig.youtube) && (
              <Fragment>
                <div className="footer-social">
                  {!!siteConfig.facebook && (
                    <FontAwesomeIcon
                      icon={faFacebook as any}
                      onClick={() => openInNewWindow(siteConfig.facebook)}
                    />
                  )}
                  {!!siteConfig.instagram && (
                    <FontAwesomeIcon
                      icon={faInstagram as any}
                      onClick={() => openInNewWindow(siteConfig.instagram)}
                    />
                  )}
                  {!!siteConfig.twitter && (
                    <FontAwesomeIcon
                      icon={faTwitter as any}
                      onClick={() => openInNewWindow(siteConfig.twitter)}
                    />
                  )}
                  {!!siteConfig.google && (
                    <FontAwesomeIcon
                      icon={faGoogle as any}
                      onClick={() => openInNewWindow(siteConfig.google)}
                    />
                  )}
                  {!!siteConfig.youtube && (
                    <FontAwesomeIcon
                      icon={faYoutube as any}
                      onClick={() => openInNewWindow(siteConfig.youtube)}
                    />
                  )}
                </div>
              </Fragment>
            )}
        </div>
        <div className="col-md-3 col-12">
          {!!siteConfig?.languages?.length && !!siteConfig.languages[0].address && (
            <div>
              <FontAwesomeIcon icon={faLocationDot as any} className="mr-5" />{' '}
              {siteConfig.languages[0].address}
            </div>
          )}
          {!!siteConfig?.phone1 && (
            <a href={'tel:' + siteConfig.phone1}>
              <FontAwesomeIcon icon={faPhone as any} className="mr-5" /> {siteConfig.phone1}
            </a>
          )}
          {!!siteConfig?.email1 && (
            <a href={'mailto:' + siteConfig.email1}>
              <FontAwesomeIcon icon={faEnvelope as any} className="mr-5" /> {siteConfig.email1}
            </a>
          )}
        </div>
        {!!footer?.footerPage?.languages?.length && (
          <div
            className="col-md-6 col-12"
            dangerouslySetInnerHTML={{
              __html: footer.footerPage.languages[0].title.body || '',
            }}
          ></div>
        )}
      </div>
      <div className="footer-col-bottom">
        <div>
          Сделано
          <a href="https://www.beprotravel.com/" target="_blank" rel="noreferrer">
            BePro Travel
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
